export const FREQUENCY_DISPLAYS = {
  ONCE_A_DAY: 'Once a day',
  TWICE_A_DAY: 'Twice a day',
  THRICE_A_DAY: 'Thrice a day',
  FOUR_TIMES_A_DAY: 'Four times a day',
  TAKE_AS_NEEDED: 'Take as needed',
  ONCE_DAILY_AT_BEDTIME: 'Once daily, at bedtime',
  ONCE_DAILY_IN_MORNING: 'Once daily, in the morning',
  ONCE_DAILY_BEFORE_BREAKFAST: 'Once daily, before Breakfast',
  ONCE_DAILY_AFTER_BREAKFAST: 'Once daily, after Breakfast',
  ONCE_DAILY_AFTER_DINNER: 'Once daily, after Dinner',
  TWICE_DAILY_BEFORE_MEALS: 'Twice daily before meals',
  TWICE_DAILY_AFTER_MEALS: 'Twice daily after meals',
  THRICE_DAILY_AFTER_MEALS: 'Thrice daily, after meals',
  THRICE_DAILY_BEFORE_MEALS: 'Thrice daily, before meals',
  EVERY_4_HOURS: 'Every 4 hours',
  EVERY_6_HOURS: 'Every 6 hours',
  EVERY_8_HOURS: 'Every 8 hours',
  ONCE_A_WEEK: 'Once a week',
} as const;
